import { useLanguage } from '@/hooks/useLanguage';
import { Layout } from '@/components/layout/Layout';
import { SEOHead } from '@/components/SEOHead';
import { OrganizationSchema, WebsiteSchema } from '@/components/StructuredData';
import { HeroSection } from '@/components/home/HeroSection';
import { WhatIsSection } from '@/components/home/WhatIsSection';
import { FourPathsSection } from '@/components/home/FourPathsSection';
import { HowToUseSection } from '@/components/home/HowToUseSection';
import { StartHereSection } from '@/components/home/StartHereSection';
import { AboutSection } from '@/components/home/AboutSection';
import { ArticleCard } from '@/components/home/ArticleCard';
import { getLatestArticles } from '@/data/articleIndex';

const SectionDivider = () => (
  <div className="max-w-5xl mx-auto px-4">
    <div className="h-px bg-gradient-to-r from-transparent via-border/40 to-transparent" />
  </div>
);

const Home = () => {
  const { t } = useLanguage();
  const latestArticles = getLatestArticles(4);

  return (
    <Layout>
      <SEOHead
        title="Alternative Living & Off-Grid Lifestyle"
        description="Discover the art of alternative living — from vans and tiny homes to boats and off-grid cabins. Personal insights, honest tips, and inspiration."
        path=""
      />
      <OrganizationSchema />
      <WebsiteSchema />

      <HeroSection />
      
      <WhatIsSection />

      <SectionDivider />

      <FourPathsSection />

      <SectionDivider />

      <HowToUseSection />

      <StartHereSection />

      <SectionDivider />

      {/* Latest Articles Section */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <h2 className="font-serif text-3xl md:text-4xl font-semibold text-primary text-center mb-12">
            {t('home.latestArticles')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {latestArticles.map((article, index) => (
              <ArticleCard key={article.id} article={article} index={index} />
            ))}
          </div>
        </div>
      </section>

      <SectionDivider />

      <AboutSection />
    </Layout>
  );
};

export default Home;
